module.exports = __webpack_public_path__ + "img/Group.5284f8d0.png";